











import { Prop, Component, Vue } from "vue-property-decorator";
import { Project } from "@/api/project-api";
import { getStatusName, getStatusCode } from "@/status";

@Component({})
export default class ProjectNewStatus extends Vue {
  @Prop({ required: true }) project!: Project;
  @Prop({ default: "md" }) size!: string;

  get status() {
    let statusObject = {
      name: getStatusName(this.project.statusProject),
      color: this.project.colorName
    };

    if (this.project.statusProject == getStatusCode("入金済")) {
      return {
        ...statusObject,
        color: "#a4a4a4"
      };
    }

    return statusObject;
  }
}
